import { Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const GridWrapper = styled.div<{
  $itemCount: number;
  $breakpoint: Breakpoints;
}>`
  display: grid;
  gap: 16px;

  grid-template-columns: repeat(2, 1fr);

  ${({ $breakpoint }) => {
    if ($breakpoint !== 'mobile') {
      return css`
        @media (max-width: 500px) {
          grid-template-columns: 1fr;
        }
      `;
    }
  }}
`;

export const GridItem = styled.div<{ $ultimoItemCentralizado?: boolean }>`
  ${({ $ultimoItemCentralizado }) =>
    $ultimoItemCentralizado &&
    css`
      grid-column: span 2;
      display: flex;
      justify-content: center;
    `}
`;
